import { render } from "./ResetPasswordEmail.vue?vue&type=template&id=2e6111fa&lang=html"
import script from "./ResetPasswordEmail.vue?vue&type=script&lang=js"
export * from "./ResetPasswordEmail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__